import React, {useEffect, useState} from "react"
import StandardList from "../../../common/listing/list.component"
import {Intl} from "../../../state/helpers/IntlProps"
import {defineMessages, injectIntl} from "react-intl"
import RowCustomStatusModal from "../component/RowCustomStatusModal"
import {Button} from "react-bootstrap"
import Icon from "../../../common/icon/icon.component"
import RowCustomStatusService from "../../../state/pricing/rowcustomstatus/RowCustomStatusService"
import RowCustomStatus, {RowCustomStatusAttributes} from "../../../state/pricing/rowcustomstatus/RowCustomStatus"
import { isError} from "../../../state/helpers/Error"
import {Row} from "../../../common/listing/ListingTypes"
import {RowCustomStatusRankUpdateDto} from "../../../state/pricing/rowcustomstatus/RowCustomStatusTypes"
import "../../../common/Prototype"

const messages = defineMessages({
    header: {
        id: "pricing.row_custom_status.section.header",
        defaultMessage: "Name"
    },
    createButton: {
        id: "pricing.row_custom_status.section.btn",
        defaultMessage: "Create Row status"
    }
})

type Props = {
    intl: Intl
}

const RowCustomStatusSection = (props: Props) => {
    const [showModal, setShowModal] = useState(false)
    const [data, setData] = useState<RowCustomStatus[]>([])
    const [selectedRowCustomStatus, setSelectedRowCustomStatus] = useState<RowCustomStatus | null>(null)

    useEffect(() => {
        (async (): Promise<void> => {
            const res = await RowCustomStatusService.GetAll()
            if (!isError(res)) {
                setData(res)
            }
        })()
    }, [])

    const onSave = async (dto: RowCustomStatusAttributes): Promise<void> => {
        if (selectedRowCustomStatus) {
            const res = await RowCustomStatusService.Update(selectedRowCustomStatus.getId(), dto)
            if (!isError(res)) {
                data.updateEntity(res)
                setSelectedRowCustomStatus(null)
            }
        } else {
            const res = await RowCustomStatusService.Create(dto)
            if (!isError(res)) {
                data.push(res)
            }
        }
        setShowModal(false)
    }

    const onDelete = async ()=> {
        if (selectedRowCustomStatus) {
            const res = await RowCustomStatusService.Delete(selectedRowCustomStatus.getId())
            if (!isError(res)){
                data.removeEntity(selectedRowCustomStatus)
            }
        }
        setShowModal(false)
        setSelectedRowCustomStatus(null)
    }

    const onHideModal = () => {
        setShowModal(false)
        setSelectedRowCustomStatus(null)
    }

    const onRowClick = (status: RowCustomStatus) => {
        setSelectedRowCustomStatus(status)
        setShowModal(true)
    }

    const onRowOrdered = async (orderedRows: Row<RowCustomStatus>[])=> {
        const dto: RowCustomStatusRankUpdateDto = {rankOrder:[]}
        dto.rankOrder = orderedRows.map(r => r.rowId)
        await RowCustomStatusService.UpdateRanks(dto)
    }

    const rows: Row<RowCustomStatus>[] = data.map(s => {
        return {
            rowId: s.getId(),
            data: [<Button key={0} variant={s.getColor()}>{s.getName()}</Button>],
            metadata: s
        }
    })

    return (
        <>
            <div className="row ui-has-modules py-1 pt-4">
                <div className="col-12 ui-module mb-0">
                    <div className="row mb-0 justify-content-end">
                        <div className="col-3 text-align-right ">
                            <Button onClick={() => setShowModal(true)} className="btn btn-primary">
                                <Icon className={"mr-1"} value={"plus-circle"}/>
                                {props.intl.formatMessage(messages["createButton"])}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {showModal &&
                <RowCustomStatusModal
                    show={showModal}
                    status={selectedRowCustomStatus}
                    onHideCallback={onHideModal}
                    onSaveCallback={onSave}
                    onDeleteCallback={onDelete}/>
            }

            {data.length > 0 &&
                <StandardList
                    sortable={true}
                    didSorted={onRowOrdered}
                    onRowClick={onRowClick}
                    className="row pt-3"
                    headers={[props.intl.formatMessage(messages["header"])]}
                    rows={rows}
                    smallLine={true}/>
            }
        </>
    )
}

export default injectIntl(RowCustomStatusSection)


// WEBPACK FOOTER //
// ./src/pricing/rowcustomstatus/section/RowCustomStatusSection.tsx